import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-shortcut-tile',
  styleUrls: ['./shortcut-tile.component.scss'],
  template: `
    <a
      class="tile"
      [class.small]="size === 'small'"
      [class.placeholder]="placeholder"
      [ngClass]="accentClass"
      [routerLink]="placeholder ? null : route"
      (click)="placeholder && $event.preventDefault()"
    >
      <mat-icon class="icon">{{ iconName }}</mat-icon>
      <span class="label"
        >{{ displayName }}<span class="context" *ngIf="contextLabel">
          ({{ contextLabel }})</span
        ></span
      >
    </a>
  `,
})
export class ShortcutTileComponent {
  @Input() displayName: string
  @Input() iconName: string
  @Input() route: string
  @Input() accentClass: string
  @Input() contextLabel: string | null = null
  @Input() size: 'small' | 'default' = 'default'
  @Input() placeholder = false
}
